module.exports = __webpack_public_path__ + "media/images/e-kvitok/train_white-cc4de28312f0bac3cb2992c21cededd1.svg";